<template>
  <div class="gov-info-list">
    <div class="top-banner-box">
      <div
        class="top-banner-img"
        :style="{ backgroundImage: `url(${headerBgUrl})` }"
      ></div>
    </div>
    <div class="container">
      <div
        class="flex"
        style="align-items: center;margin-bottom: 15px;padding-top: 15px;"
      >
        <span style="font-size: 14px;">当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item style="cursor: pointer;" :to="{ name: 'govInfo' }"
            >政务信息</el-breadcrumb-item
          >
          <el-breadcrumb-item style="color: #009999"
            >全部信息</el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="list-search-type">
        <div
          class="list-search-item"
          :style="item.uuid === params.programUuid ? 'color: #009999;' : ''"
          v-for="item in paramsTypeList"
          @click="onClickType(item)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="list-search-line" />
      <div class="list-box" v-if="dataList.length" v-loading="dataLoading">
        <el-row :gutter="20" class="tender-tab">
          <el-col :span="5" v-for="(item, index) in dataList" :key="index">
            <div class="list-item-box" @click="onClickDetail(item)">
              <img class="list-item-img" :src="`${item.pic}`" alt="" />
              <div class="list-item-text">
                <div class="over-num-lines list-item-title">
                  {{ item.title }}
                </div>
                <div class="over-num-lines over-2-lines list-item-des">
                  {{ item.summary }}
                </div>
                <div class="list-item-bottom">
                  <div class="over-num-lines list-item-date">
                    {{ item.createDate }}
                  </div>
                  <div>
                    <i class="el-icon-view"></i>
                    <span> {{ item.viewCount }}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-else style="text-align:center;padding:20px 0;">
        <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px" />
      </div>
      <div style="text-align: center;padding: 10px 0;" v-if="dataList.length">
        <el-pagination
          @current-change="onChangeCurrent"
          :current-page="params.current"
          :page-size="params.pageSize"
          background
          layout="prev, pager, next"
          :total="params.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDictionaryItem,
  getGovHomeBtnList,
  getGovHomeBtnType,
} from "../../utils/interface"

export default {
  //   政务信息列表页
  name: "saasList",
  metaInfo: {
    title: "政务信息-宁夏工业企业数字化转型公共服务平台", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "saas平台 | 信息化软件 |人力资源软件 | SRM |crm |MES系统 | 生产管理软件 | 党建管理软件",
      },
      {
        // set meta
        name: "description",
        content:
          "宁夏工业企业数字化转型公共服务平台政务信息提供人力资源、行政、采购、营销、财务、党政等信息化产品软件服务，为水泵行业企业提供完整的信息化解决方案。",
      },
    ],
  },
  components: {},
  data() {
    return {
      headerBgUrl: "",
      params: {
        programUuid: "",
        status: "1",
        current: 1,
        pageSize: 15,
        total: 1,
      },
      paramsTypeList: [],
      dataList: [],
      dataLoading: false,
    }
  },
  created() {
    if (this.$route.query.programUuid) {
      this.params.programUuid = this.$route.query.programUuid
    }
    this.getOptionsData()
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.dataLoading = true
      getGovHomeBtnList(this.params)
        .then((res) => {
          if (res.list) {
            this.dataList = res.list
            this.params.total = res.total
          }
          this.dataLoading = false
        })
        .catch((err) => {
          this.dataLoading = false
        })
    },
    getOptionsData() {
      //顶部轮播图
      getDictionaryItem({
        code: "ZWXX_LIST_BANNER",
      }).then((res) => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value
        } else {
          this.headerBgUrl = ""
        }
      })
      //上面分类列表
      getGovHomeBtnType({ pageSize: "99", status: "1" }).then((res) => {
        if (res.list) {
          let all = res.list
          this.paramsTypeList = [{ title: "全部", uuid: "" }, ...all]
        }
      })
    },
    onClickType(item) {
      this.params.programUuid = item.uuid
      this.getDataList()
    },
    onChangeCurrent(e) {
      this.params.current = e
      this.getDataList()
    },
    onClickDetail(item) {
      let routeData = this.$router.resolve({
        name: "govInfoDetail",
        query: {
          uuid: item.uuid,
          titleName: "政务列表",
          titleForm: "govInfoList",
        },
      })
      window.open(routeData.href, "_blank")
    },
  },
}
</script>

<style scoped lang="less">
@basic-colors: #009999;
.gov-info-list {
  background: #f4f4f4;

  //超出指定行换行
  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .over-1-lines {
    -webkit-line-clamp: 1;
  }

  .over-2-lines {
    -webkit-line-clamp: 2;
  }

  .over-4-lines {
    -webkit-line-clamp: 4;
  }

  .top-banner-box {
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .container {
    width: 1200px;
    margin: 0 auto;
  }

  .list-search-type {
    display: flex;
    padding-top: 10px;
    padding-bottom: 30px;
  }

  .list-search-item {
    color: #777777;
    padding-right: 10px;
    margin-right: 10px;
    border-right: 1px solid #cecece;
    cursor: pointer;
    user-select: none;
  }

  .list-search-item:last-child {
    border-right: none;
  }

  .list-search-item:hover {
    color: @basic-colors;
  }

  .list-search-line {
    width: 100%;
    height: 1px;
    background-color: #cecece;
  }

  .list-box {
    margin-top: 30px;
  }

  /deep/ .el-col-5 {
    max-width: 20%;
    flex: 0 0 20%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .list-item-box {
    width: 100%;
    background-color: white;
    border-radius: 10px;
    margin-bottom: 20px;
    box-shadow: rgba(0, 0, 0, 0.05) 0 1px 5px;
    transition: all 0.2s;
    cursor: pointer;
  }

  .list-item-box:hover {
    transform: scale(1.02);
    box-shadow: rgba(0, 0, 0, 0.2) 0 5px 15px;
  }

  .list-item-box:active {
    transform: scale(1);
  }

  .list-item-img {
    height: 110px;
    width: 100%;
    border-radius: 10px 10px 0 0;
  }

  .list-item-text {
    height: 112px;
    padding: 10px;
  }

  .list-item-title {
    color: #333333;
    font-weight: bold;
  }

  .list-item-des {
    height: 38px;
    margin-top: 15px;
    font-size: 14px;
    color: #777777;
  }

  .list-item-bottom {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #777777;
  }

  .list-item-date {
    font-size: 14px;
    color: #777777;
  }

  .el-icon-view {
    margin-right: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/govInfo/infoList.vue